(function(){
  'use strict';

  var cfg=window.LMP_APP_CONFIG||{};
  var sheet=null;
  var menuMarkupCache=null;
  var normalizedItemCache = new WeakMap();
  function itemLabel(el){
    if(normalizedItemCache.has(el))return normalizedItemCache.get(el);
    var label=norm(el.getAttribute('data-title')||el.textContent);
    normalizedItemCache.set(el,label);
    return label;
  }

  function esc(v){
    return String(v==null?'':v)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }
  function norm(v){
    try{return String(v||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim()}
    catch(e){return String(v||'').toLowerCase().trim()}
  }
  function readMenu(){
    try{
      var el=document.getElementById('lmp-mobile-menu-data');
      var data=el?JSON.parse(el.textContent||'[]'):[];
      return Array.isArray(data)?data:[];
    }catch(e){return []}
  }
  function withPreview(raw){
    raw=raw||'/';
    try{
      var u=new URL(raw,location.origin);
      if(u.origin!==location.origin)return u.href;
      var q=new URLSearchParams(u.search);
      if(cfg.previewMode){
        var here=new URLSearchParams(location.search);
        var theme=here.get('preview_theme_id');
        if(theme)q.set('preview_theme_id',theme);
        q.set('lmp_app_preview','1');
      }
      return u.pathname+(q.toString()?'?'+q.toString():'')+u.hash;
    }catch(e){return raw}
  }
  function root(){
    return document.getElementById('lmp-native-app');
  }
  function iconFor(title){
    var t=norm(title);
    if(t.indexOf('visage')>-1||t.indexOf('corps')>-1)return '✦';
    if(t.indexOf('cheveux')>-1)return '⌁';
    if(t.indexOf('solaire')>-1)return '☼';
    if(t.indexOf('hygiene')>-1||t.indexOf('sante')>-1)return '＋';
    if(t.indexOf('complement')>-1)return '●';
    return '◇';
  }
  function childrenOf(item){
    return item&&Array.isArray(item.children)?item.children:[];
  }
  function isRootLink(url){
    if(!url)return true;
    try{return new URL(url,location.origin).pathname==='/'}
    catch(e){return url==='/'}
  }
  function link(title,url,klass){
    return '<a class="'+klass+' lmp-mega-filter-item" data-lmp-mega-link data-title="'+esc(title)+'" href="'+esc(withPreview(url||'/'))+'">'+esc(title)+'</a>';
  }
  function categoryHtml(data){
    var roots=data.filter(function(item){
      var t=norm(item.title);
      return t.indexOf('marque')===-1&&t.indexOf('info')===-1;
    });
    if(!roots.length)return '<div class="lmp-mega-empty">Les catégories seront affichées ici.</div>';
    return roots.map(function(item,index){
      var groups=childrenOf(item);
      var body='';
      groups.forEach(function(group){
        var subs=childrenOf(group);
        if(subs.length){
          body+='<section class="lmp-mega-group"><a class="lmp-mega-group-head lmp-mega-filter-item" data-lmp-mega-link data-title="'+esc(group.title)+'" href="'+esc(withPreview(group.url||'/'))+'"><span>'+esc(group.title)+'</span><span>Voir tout →</span></a><div class="lmp-mega-subgrid">'+subs.map(function(sub){return link(sub.title,sub.url,'lmp-mega-link')}).join('')+'</div></section>';
        }else{
          body+=link(group.title,group.url,'lmp-mega-direct');
        }
      });
      if(!groups.length&&!isRootLink(item.url))body+=link('Voir '+item.title,item.url,'lmp-mega-direct');
      if(!isRootLink(item.url)&&groups.length){
        body+='<a class="lmp-mega-broad lmp-mega-filter-item" data-lmp-mega-link data-title="'+esc(item.title)+'" href="'+esc(withPreview(item.url))+'">Voir tout : '+esc(item.title)+'</a>';
      }
      return '<details class="lmp-mega-dept" '+(index===0?'open':'')+'><summary><span class="lmp-mega-dept-icon" aria-hidden="true">'+iconFor(item.title)+'</span><span>'+esc(item.title)+'</span><svg class="lmp-mega-chevron" viewBox="0 0 24 24"><path d="m9 5 7 7-7 7"/></svg></summary><div class="lmp-mega-dept-body">'+body+'</div></details>';
    }).join('');
  }
  function brandsHtml(data){
    var brandRoot=null;
    data.some(function(item){
      if(norm(item.title).indexOf('marque')>-1){brandRoot=item;return true}
      return false;
    });
    var brands=childrenOf(brandRoot);
    if(!brands.length)return '<div class="lmp-mega-empty">Les marques seront affichées ici.</div>';
    return '<div class="lmp-mega-brands">'+brands.map(function(item){
      var all=norm(item.title).indexOf('toutes les marques')>-1;
      return '<a class="lmp-mega-brand lmp-mega-filter-item '+(all?'lmp-mega-brand--all':'')+'" data-lmp-mega-link data-title="'+esc(item.title)+'" href="'+esc(withPreview(item.url||'/'))+'">'+esc(item.title)+'</a>';
    }).join('')+'</div>';
  }
  function warmMenuMarkup(){
    if(menuMarkupCache)return;
    var data=readMenu();
    menuMarkupCache={categories:categoryHtml(data),brands:brandsHtml(data)};
  }
  function scheduleMenuWarmup(){
    if(!(cfg.standalone||cfg.previewMode))return;
    if('requestIdleCallback' in window)window.requestIdleCallback(function(deadline){if(deadline.timeRemaining()<8&&!deadline.didTimeout){window.requestIdleCallback(warmMenuMarkup,{timeout:8000});return;}warmMenuMarkup();},{timeout:5000});
    else window.setTimeout(warmMenuMarkup,1800);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scheduleMenuWarmup,{once:true});
  else scheduleMenuWarmup();
  function setTab(name){
    if(!sheet)return;
    sheet.querySelectorAll('[data-lmp-mega-tab]').forEach(function(btn){
      btn.classList.toggle('is-active',btn.getAttribute('data-lmp-mega-tab')===name);
      btn.setAttribute('aria-selected',btn.getAttribute('data-lmp-mega-tab')===name?'true':'false');
    });
    sheet.querySelectorAll('[data-lmp-mega-panel]').forEach(function(panel){
      panel.hidden=panel.getAttribute('data-lmp-mega-panel')!==name;
    });
    var input=sheet.querySelector('[data-lmp-mega-search]');
    if(input){input.value='';filterMenu('')}
  }
  function filterMenu(query){
    if(!sheet)return;
    var q=norm(query);
    sheet.querySelectorAll('.lmp-mega-filter-item').forEach(function(el){
      var hit=!q||itemLabel(el).indexOf(q)>-1;
      el.hidden=!hit;
    });
    sheet.querySelectorAll('.lmp-mega-dept').forEach(function(dept){
      if(!q){dept.hidden=false;return}
      var title=(dept.querySelector('summary')||{}).textContent||'';
      var rootHit=norm(title).indexOf(q)>-1;
      var childHit=!!dept.querySelector('.lmp-mega-filter-item:not([hidden])');
      dept.hidden=!(rootHit||childHit);
      if(rootHit||childHit)dept.open=true;
    });
    var active=sheet.querySelector('.lmp-mega-panel:not([hidden])');
    var hasVisible=active&&active.querySelector('.lmp-mega-filter-item:not([hidden]),.lmp-mega-dept:not([hidden])');
    var none=sheet.querySelector('.lmp-mega-no-results');
    if(none)none.classList.toggle('is-visible',!!q&&!hasVisible);
  }
  function buildSheet(){
    var app=root();
    if(!app)return null;
    var data=menuMarkupCache?null:readMenu();
    var el=document.createElement('section');
    el.className='lmp-mega-sheet';
    el.setAttribute('role','dialog');
    el.setAttribute('aria-modal','true');
    el.setAttribute('aria-label','Catégories');
    el.innerHTML=
      '<header class="lmp-mega-head">'+
        '<div class="lmp-mega-head__mark" aria-hidden="true">≡</div>'+
        '<div class="lmp-mega-head__title"><strong>Catégories</strong><small>Tout La Maison Para</small></div>'+
        '<button class="lmp-mega-close" type="button" data-lmp-mega-close aria-label="Fermer">×</button>'+
      '</header>'+
      '<div class="lmp-mega-tools">'+
        '<label class="lmp-mega-search">'+
          '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg>'+
          '<input type="search" data-lmp-mega-search autocomplete="off" placeholder="Chercher une catégorie ou une marque">'+
        '</label>'+
        '<div class="lmp-mega-tabs" role="tablist">'+
          '<button class="lmp-mega-tab is-active" type="button" role="tab" aria-selected="true" data-lmp-mega-tab="categories">Catégories</button>'+
          '<button class="lmp-mega-tab" type="button" role="tab" aria-selected="false" data-lmp-mega-tab="marques">Marques</button>'+
        '</div>'+
      '</div>'+
      '<div class="lmp-mega-scroll">'+
        '<div class="lmp-mega-panel" data-lmp-mega-panel="categories">'+(menuMarkupCache?menuMarkupCache.categories:categoryHtml(data))+'</div>'+
        '<div class="lmp-mega-panel" data-lmp-mega-panel="marques" hidden>'+(menuMarkupCache?menuMarkupCache.brands:brandsHtml(data))+'</div>'+
        '<div class="lmp-mega-no-results">Aucun résultat dans ce menu.</div>'+
      '</div>';
    var shell=app.querySelector('.lmp-native-shell');
    if(!shell)return null;
    shell.appendChild(el);
    el.querySelector('[data-lmp-mega-close]').addEventListener('click',closeMega);
    el.querySelectorAll('[data-lmp-mega-tab]').forEach(function(btn){
      btn.addEventListener('click',function(){setTab(btn.getAttribute('data-lmp-mega-tab'))});
    });
    var input=el.querySelector('[data-lmp-mega-search]');
    if(input){
      var filterTimer=null;
      input.addEventListener('input',function(){
        if(filterTimer!==null)window.clearTimeout(filterTimer);
        filterTimer=window.setTimeout(function(){filterTimer=null;filterMenu(input.value);},90);
      });
      input.addEventListener('keydown',function(e){
        if(e.key==='Enter'){
          e.preventDefault();
          var q=input.value.trim();
          if(q)location.href=withPreview('/search?q='+encodeURIComponent(q));
        }
      });
    }
    el.addEventListener('click',function(e){
      var a=e.target.closest('[data-lmp-mega-link]');
      if(a)closeMega();
    });
    return el;
  }
  function markCategories(active){
    var app=root();
    if(!app)return;
    app.querySelectorAll('.lmp-native-nav a').forEach(function(a){
      var p='';
      try{p=new URL(a.href,location.href).pathname}catch(e){}
      if(p==='/pages/categories-parapharmacie')a.classList.toggle('is-active',active);
    });
  }
  function openMega(){
    var app=root();
    if(!app)return;
    if(!sheet||!document.documentElement.contains(sheet))sheet=buildSheet();
    if(!sheet)return;
    app.classList.add('lmp-mega-open');
    sheet.classList.add('is-open');
    markCategories(true);
    window.setTimeout(function(){
      var input=sheet&&sheet.querySelector('[data-lmp-mega-search]');
      if(input){try{input.focus({preventScroll:true})}catch(e){input.focus()}}
    },310);
  }
  function closeMega(){
    var app=root();
    if(!sheet||!app)return;
    sheet.classList.remove('is-open');
    app.classList.remove('lmp-mega-open');
    var onCategories=location.pathname==='/pages/categories-parapharmacie';
    markCategories(onCategories);
  }

  document.addEventListener('click',function(e){
    var a=e.target&&e.target.closest?e.target.closest('#lmp-native-app .lmp-native-nav a'):null;
    if(!a)return;
    var p='';
    try{p=new URL(a.href,location.href).pathname}catch(x){}
    if(p==='/pages/categories-parapharmacie'){
      e.preventDefault();
      e.stopPropagation();
      if(sheet&&sheet.classList.contains('is-open'))closeMega();else openMega();
    }
  },true);

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&sheet&&sheet.classList.contains('is-open'))closeMega();
  });

  window.addEventListener('pageshow',function(){
    var app=root();
    if(app)app.querySelectorAll('.lmp-topbar [data-lmp-cart]').forEach(function(btn){btn.remove()});
  });

  function init(){
    var app=root();
    if(!app)return;
    app.querySelectorAll('.lmp-topbar [data-lmp-cart]').forEach(function(btn){btn.remove()});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();